/**
 * Pure path helpers for the compliance trees.
 *
 * Compliance is tenant-scoped like settings: the canonical URLs are
 * `/$org/compliance/$section`, so the organization a policy belongs to is in
 * the URL — visible, bookmarkable, and impossible to infer wrongly. The
 * org-less `/compliance/*` tree survives only as a redirector for old links
 * and for servers with no tenant directory.
 *
 * `regulation` is the tree's former name. It stays matched here because the
 * old URLs redirect rather than 404, and the chrome renders for a beat before
 * the redirect resolves — dropping it made the compliance sidebar fail to
 * appear at all on the renamed routes (the miss this comment exists to
 * prevent repeating: the prefix lives in a regex, so a rename that only
 * rewrites route strings silently skips it).
 *
 * @module components/regulation/regulationPaths
 */

/** The section a compliance pathname points at, in either tree, or null. */
export function regulationSectionFromPathname(pathname: string): string | null {
  const match = /^(?:\/[^/]+)?\/(?:compliance|regulation)(?:\/(.*))?$/.exec(pathname);
  return match ? (match[1] ?? "") : null;
}

/** True on both regulation trees; the chrome swaps in the regulation sidebar. */
export function isRegulationPathname(pathname: string): boolean {
  return regulationSectionFromPathname(pathname) !== null;
}
